import React from 'react';
import { Users, FileText, UserCheck, Calendar, Briefcase, Target } from 'lucide-react';

function JobFunnel() {
  return (
    <section className="max-w-5xl mx-auto px-6 py-10 bg-white">
      {/* Header */}
      <div className="max-w-2xl mb-16 mx-auto text-center">
        <h2 className="text-4xl font-bold sm:text-5xl md:text-6xl">
          The Reality of Your Job Search
        </h2>
        <p className="pt-8 text-base leading-normal text-gray-500 tracking-normal">
          Over 70% of people are looking for a new job at any given time. Here's what the typical hiring funnel looks like for a <i>single</i> online job posting:
        </p>
      </div>

      {/* Funnel Visualization */}
      <div className="max-w-4xl mx-auto space-y-4">
        {/* Applications - 250 */}
        <div className="bg-blue-50 p-6 rounded-xl w-full">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-100 rounded-lg">
                <FileText className="w-5 h-5 text-blue-600" />
              </div>
              <span className="font-medium text-gray-900">Initial Applications</span>
            </div>
            <span className="text-2xl font-bold text-blue-600">250</span>
          </div>
        </div>

        {/* ATS Screening - 225 */}
        <div className="bg-rose-50 rounded-xl p-6 w-[90%] md:w-[85%] mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-rose-100 rounded-lg">
                <Users className="w-5 h-5 text-rose-600" />
              </div>
              <span className="font-medium text-gray-900">ATS/Recruiter Screens Out</span>
            </div>
            <span className="text-2xl font-bold text-rose-600">-240</span>
          </div>
        </div>

        {/* Manager Review - 25 */}
        <div className="bg-purple-50 rounded-xl p-6 w-[80%] md:w-[70%] mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-1 bg-purple-100 rounded-lg">
                <UserCheck className="w-5 h-5 text-purple-600" />
              </div>
              <span className="font-medium text-gray-900">Hiring Manager Sees</span>
            </div>
            <span className="text-2xl font-bold text-purple-600">10</span>
          </div>
        </div>

        {/* First Interview - 4-6 */}
        <div className="bg-amber-50 rounded-xl p-6 w-[70%] md:w-[50%] mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-amber-100 rounded-lg">
                <Calendar className="w-5 h-5 text-amber-600" />
              </div>
              <span className="font-medium text-gray-900">Initial Interview</span>
            </div>
            <span className="text-2xl font-bold text-amber-600 whitespace-nowrap pl-2">4-6</span>
          </div>
        </div>

        {/* Final Interview - 1-3 */}
        <div className="bg-indigo-50 rounded-xl p-6 w-[60%] md:w-[40%] mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-indigo-100 rounded-lg">
                <Target className="w-5 h-5 text-indigo-600" />
              </div>
              <span className="font-medium text-gray-900">Final Interview</span>
            </div>
            <span className="text-2xl font-bold text-indigo-600 whitespace-nowrap pl-2">1-2</span>
          </div>
        </div>

        {/* Job Offer - 1 */}
        <div className="bg-green-50 rounded-xl p-6 rounded-b-xl w-[50%] md:w-[30%] mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-1 bg-green-100 rounded-lg">
                <Briefcase className="w-5 h-5 text-green-600" />
              </div>
              <span className="font-medium text-gray-900">Job Offer</span>
            </div>
            <span className="text-2xl font-bold text-green-600">1</span>
          </div>
        </div>
      </div>


    </section>
  );
}

export default JobFunnel;